module.exports = function(x, y, $elem, requiredSelector) {

    // Figure out the padding, because of possible negative margins, etc.
    var containerStyle = $elem[0].currentStyle || window.getComputedStyle($elem[0]);
    var containerPaddingLeft = parseFloat(containerStyle.paddingLeft);
    var containerPaddingRight = parseFloat(containerStyle.paddingRight);
    var containerPaddingTop = parseFloat(containerStyle.paddingTop);

    var results = [];

    $elem.children().filter(':visible').each(function() {

        var $childElem = $(this);

        if (requiredSelector) {
            if (!$childElem.find(requiredSelector).length) {
                return true;
            }
        }

        // Get the position of the element with respect to the viewport
        var childPosition = $childElem[0].getBoundingClientRect();

        // Compute the margins and padding
        var childStyle = $childElem[0].currentStyle || window.getComputedStyle($childElem[0]);
        var marginTop = parseFloat(childStyle.marginTop);
        var marginLeft = parseFloat(childStyle.marginLeft);
        var marginBottom = parseFloat(childStyle.marginBottom);
        var paddingBottom = parseFloat(childStyle.paddingBottom);

        // Figure out the true bounding box of the element, taking into consideration
        // container padding and element margin
        var childMinX = childPosition.left;
        var childMaxX = childPosition.left + $childElem.width() + containerPaddingLeft + containerPaddingRight;

        if (marginLeft > 0) {
            childMinX -= marginLeft;
        }

        var childMinY = childPosition.top;
        var childMaxY = childPosition.top + containerPaddingTop + $childElem.height() + paddingBottom + marginBottom;

        if (marginTop > 0) {
            childMinY -= marginTop;
        }

        // We need to special case this module because of the fact that it includes odd padding/margin
        // to accomodate the need for the right colum image to fall above the background color
        if ($childElem.hasClass('tabbed-content-module')) {
            childMinY += 56;
            childMaxY += 136;
        }

        // We store the results here instead of immediately computing the winner, because if two
        // elements both contain the point (which is possible), we want to select the one which
        // is lower on the screen
        results.push({
            elem: $childElem,
            minX: childMinX,
            maxX: childMaxX,
            minY: childMinY,
            maxY: childMaxY
        });
    });

    // Order the results to allow selecting the first element from the top which contains
    // the point
    results.sort(function(a, b) {
        return a.minY - b.minY;
    });

    // Filter to only elements which contain the point and then extract the actual element
    var filteredResults = results.filter(function(obj) {
        if (obj.minX <= x && obj.maxX >= x && obj.minY <= y && obj.maxY >= y) {
            return true;
        }
        return false;
    }).map(function(obj) {
        return obj.elem;
    });

    var $resultElem = $([]);

    // If an element contains the point, we use it, otherwise return an empty jQuery object
    if (filteredResults.length) {
        $resultElem = $(filteredResults[0]);
    }

    return $resultElem;
};